import { TextField, useTheme } from '../../../../../../base';
import { StyledOptionsContainer } from '../../JobQuestions.styles';
import { useTranslation } from 'react-i18next';

export const QuestionShortText = () => {
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <StyledOptionsContainer>
            <TextField
                disabled
                fullWidth
                size="small"
                placeholder={t('saveJob.shortTextPlaceholder')}
                sx={{
                    '& .MuiInputBase-root': {
                        backgroundColor: theme.palette.grey[100],
                        cursor: 'not-allowed',
                    },
                    '& .MuiInputBase-input': {
                        color: theme.palette.text.disabled,
                        WebkitTextFillColor: theme.palette.text.disabled,
                    },
                }}
            />
        </StyledOptionsContainer>
    );
};
